"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GKAlertsManager = exports.createAlert = exports.clearPendingAlerts = exports.pending_alerts = void 0;
var React = __importStar(require("react"));
var common_1 = require("../../../common");
var services_1 = require("../../../services");
var AlertHandle_1 = __importDefault(require("./AlertHandle"));
var GKAlertContext_1 = require("./GKAlertContext");
var GKAlertContext_models_1 = require("./GKAlertContext.models");
// alerts which have not yet made it into state
exports.pending_alerts = {};
var clearPendingAlerts = function () {
    exports.pending_alerts = {};
};
exports.clearPendingAlerts = clearPendingAlerts;
// exported for unit testing purposes
var createAlert = function (alertType, alertMessage, baseId, alertOptions, isContainerGlobal, parentContext, _a) {
    var _b, _c;
    var currentHandles = _a[0], setHandles = _a[1];
    var _d = alertOptions || {}, isAlertGlobal = _d.global, autoClose = _d.autoClose, alertProps = __rest(_d, ["global", "autoClose"]);
    if (!isContainerGlobal && isAlertGlobal) {
        return parentContext[alertType](alertMessage, alertOptions);
    }
    var newProps = __assign(__assign({}, alertProps), { color: alertType, id: (_b = alertProps.id) !== null && _b !== void 0 ? _b : services_1.uniqueIdService.getId(baseId), timeout: (_c = alertProps.timeout) !== null && _c !== void 0 ? _c : (autoClose || (alertType === "success" && autoClose !== false)
            ? GKAlertContext_models_1.DEFAULT_TIMEOUT
            : undefined) });
    // dedupe by id
    var duplicate = exports.pending_alerts[newProps.id] ||
        currentHandles.find(function (h) { return h.props.id === newProps.id; });
    if (duplicate) {
        duplicate.reset(alertMessage, newProps);
        return duplicate;
    }
    else {
        var newHandle_1 = new AlertHandle_1.default(alertMessage, newProps, function () {
            return setHandles(function (handles) { return handles.filter(function (a) { return !a.isDismissed; }); });
        });
        exports.pending_alerts[newProps.id] = newHandle_1;
        setHandles(function (handles) {
            delete exports.pending_alerts[newProps.id];
            return __spreadArray(__spreadArray([], handles, true), [newHandle_1], false);
        });
        return newHandle_1;
    }
};
exports.createAlert = createAlert;
/* eslint-disable prettier/prettier */
var getMyProviderValue = function (baseId, isGlobal, parentContext, alertState) {
    var alerts = alertState[0];
    var dispatchers = {};
    GKAlertContext_models_1.ALERT_TYPES.forEach(function (type) { return dispatchers[type] = function (msg, opts) { return (0, exports.createAlert)(type, msg, baseId, opts, isGlobal, parentContext, alertState); }; });
    var provider = __assign({ id: baseId, alerts: alerts.map(function (a) { return (__assign(__assign({}, a.props), { children: a.message })); }), global: undefined, dismissAll: function () { return alerts.forEach(function (a) { return a.dismiss(); }); } }, dispatchers);
    provider.global =
        isGlobal || !parentContext.global ? provider : parentContext.global;
    return provider;
};
/* eslint-enable prettier/prettier */
/** GKAlertsManager - provider which handles bookkeeping for contextual alerts */
var GKAlertsManager = function (_a) {
    var baseId = _a.baseId, children = _a.children, global = _a.global;
    var uniqueId = (0, common_1.usePersistentId2)(baseId);
    var alertCtx = React.useContext(GKAlertContext_1.GKAlertContext);
    var alertState = React.useState([]);
    var providerValue = getMyProviderValue(uniqueId, global, alertCtx, alertState);
    return (React.createElement(GKAlertContext_1.GKAlertContext.Provider, { value: providerValue }, children));
};
exports.GKAlertsManager = GKAlertsManager;
exports.default = exports.GKAlertsManager;
